import { AxiosResponse } from 'axios';
import { getActiveOrgId } from '@/lib/activeOrg';
import { mapFxBankAccount } from '@/lib/mappers';
import { supabase } from '@/lib/supabase';
import { asResponse } from '@/lib/supabase-helpers';
import { FxBankAccount } from '@/types/api/finance';

const financeBankAccountsService = {
  async getAll(): Promise<AxiosResponse<FxBankAccount[]>> {
    const orgId = getActiveOrgId();

    let query = supabase
      .from('fx_bank_accounts')
      .select('*, fx_bank_connections!inner(organization_id)')
      .eq('is_active', true)
      .order('name');

    if (orgId) {
      query = query.eq('fx_bank_connections.organization_id', orgId);
    }

    const { data, error } = await query;
    if (error) throw error;

    return asResponse((data ?? []).map(mapFxBankAccount));
  },
};

export default financeBankAccountsService;
